export default __webpack_public_path__ + "static/media/primary-tablet.5920875e.png";